import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IPagedResults } from "../data/types";
import PaginationResponse from "./paginationResponse";
import PayGateToTransferRefundResponse from "./payGateToTransferRefundResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class PayGateToTransferRefundsResponse implements IPagedResults<PayGateToTransferRefundResponse> {
  @observable
  @Type(() => PaginationResponse)
  metadata!: PaginationResponse;

  @observable
  @Type(() => PayGateToTransferRefundResponse)
  items!: PayGateToTransferRefundResponse[];
}
